import { createReducer } from '@reduxjs/toolkit';
import {
  PaginationReducerPayload,
  tablePaginationCurrent,
  tablePaginationDecrement,
  tablePaginationIncrement,
  tablePaginationInitstate,
} from 'components/Table/partials/TablePagination/TablePagination.actions';

const initialState = {
  statusIndex: 1,
} as PaginationReducerPayload;

// Docs: https://redux-toolkit.js.org/api/createReducer
// CreateReducer builder api: https://redux-toolkit.js.org/api/createReducer#the-builder-callback-api
// Immer docs: https://immerjs.github.io/immer/docs/introduction
const tablePaginationReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(tablePaginationCurrent, (state, { payload: { statusIndex } }) => {
      return {
        ...state,
        statusIndex: statusIndex,
        startSlice: state.rowsPerPage * statusIndex - state.rowsPerPage,
        endSlice: state.rowsPerPage * statusIndex,
      };
    })
    .addCase(
      tablePaginationIncrement,
      (state, { payload: { statusIndex } }) => {
        return {
          ...state,
          statusIndex: statusIndex + 1,
          startSlice: state.startSlice + state.rowsPerPage,
          endSlice: state.endSlice + state.rowsPerPage,
        };
      },
    )
    .addCase(
      tablePaginationDecrement,
      (state, { payload: { statusIndex } }) => {
        return {
          ...state,
          statusIndex: statusIndex - 1,
          startSlice: state.startSlice - state.rowsPerPage,
          endSlice: state.endSlice - state.rowsPerPage,
        };
      },
    )

    .addCase(tablePaginationInitstate, (state, { payload }) => {
      return { ...state, ...payload };
    }),
);

export default tablePaginationReducer;
